@if (travelBuddySettings && travelBuddySettings.indicator?.isEnabled && isUserChatHistoryReady) {
<div *ngIf="canShowIndicator && (containerMode() !== 'app')"
  class="fixed rounded-md z-10 p-3 bg-white w-[26%] min-w-[240px] max-w-[320px] text-sm text-gray-600 mobile:!bottom-[120px] mobile:!right-[10px] ig-fade-in-down"
  [class.opacity-0]="isShow" [ngStyle]="{'right': right(), 'left': left(), 'bottom': indicatorBottom}"
  style="box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;">
  <mat-icon class="absolute -right-1.5 -top-2.5 !flex justify-center items-center rounded-full bg-white cursor-pointer"
    role="button" tabindex="0" aria-label="Dismiss travel buddy prompt" (keydown)="onPseudoButtonKeydown($event)"
    (click)="closeIndicator()">close
  </mat-icon>
  {{ travelBuddySettings.indicator?.prompt }}
</div>
}

<!-- Custom trigger icon version -->
<ng-container *ngIf="containerMode() !== 'app'">
  <div
    *ngIf="travelBuddySettings && isUserChatHistoryReady && travelBuddySettings.ui.triggerIcon?.url; else defaultTrigger"
    role="button" class="fixed cursor-pointer z-[1301] transition-all hover:scale-[1.07] mobile:!right-2 mobile:!bottom-0"
    tabindex="0" (keydown)="onPseudoButtonKeydown($event)"
    (click)="show()" [class.hidden]="isMobile && isShow"
    [style.width.px]="isMobile ? travelBuddySettings.ui.triggerIcon.widthMobile || 100 : travelBuddySettings.ui.triggerIcon.width || 160"
    [style.height.px]="isMobile ? travelBuddySettings.ui.triggerIcon.heightMobile || 100 : travelBuddySettings.ui.triggerIcon.height || 160"
    [class.!z-[1301]]="isShow" [class.!w-14]="isShow" [class.!h-14]="isShow"
    [ngStyle]="{'right': right(), 'bottom': bottom(), 'left': left(), 'top': top()}"
    [attr.aria-label]="isShow ? 'Minimize chat' : 'Open chat with AI TravelBuddy'" [attr.aria-expanded]="isShow"
    [attr.aria-controls]="'chat-container'" aria-haspopup="dialog">

    <img *ngIf="!isShow" [src]="travelBuddySettings.ui.triggerIcon.url"
      [alt]="'Chat with ' + (travelBuddySettings?.ui?.avatar?.name || 'AI Travel Planner')" class="w-full h-full">
    <mat-icon *ngIf="isShow"
      class="text-white flex items-center justify-center !text-[24px] !leading-6 !w-14 !h-14 bg-gray-600 rounded-full p-2 mobile:!text-[26px] mobile:!leading-[26px] mobile:p-3"
      aria-hidden="true">keyboard_arrow_down</mat-icon>
  </div>

  <!-- Default trigger icon (circle + avatar) -->
  <ng-template #defaultTrigger>
    <div *ngIf="travelBuddySettings && isUserChatHistoryReady" role="button"
      tabindex="0" (keydown)="onPseudoButtonKeydown($event)"
      [style.width.px]="isMobile ? travelBuddySettings.ui.triggerIcon.widthMobile || 100 : travelBuddySettings.ui.triggerIcon.width || 120"
      [style.height.px]="isMobile ? travelBuddySettings.ui.triggerIcon.heightMobile || 100 : travelBuddySettings.ui.triggerIcon.height || 120"
      class="rounded-full flex items-center justify-center fixed border-[3px] border-[orange]
          cursor-pointer z-[1300] transition-all hover:scale-[1.07] mobile:w-8 mobile:h-8 mobile:!border-4 mobile:!right-2 mobile:!bottom-2 mobile:!animate-none"
      (click)="show()" [class.!w-14]="isShow && !isMobile" [class.!h-14]="isShow && !isMobile" [class.!w-8]="isShow && isMobile" [class.!h-8]="isShow && isMobile" [class.!z-[1301]]="isShow"
      [class.!border-none]="isShow" [class.hidden]="isMobile && isShow && !isShowLandscreen"
      [ngStyle]="{'right': right(), 'bottom': bottom(), 'left': left(), 'top': top(), 'backgroundColor': travelBuddySettings.ui.color.toggleIcon}"
      [attr.aria-label]="isShow ? 'Minimize chat' : 'Open chat with AI TravelBuddy'" [attr.aria-expanded]="isShow"
      [attr.aria-controls]="'chat-container'" [class.!z-[1301]]="isChatAreaDown" aria-haspopup="dialog"
      [class.-translate-x-1]="isChatAreaDown&&isShow" [class.-translate-y-1]="isChatAreaDown&&isShow">

      <div [class.hidden]="isShow">
        <ig-image class="w-full transition-all duration-300 relative -top-8 flex justify-center mobile:-top-4"
          [src]="travelBuddySettings.ui.avatar.profile" [alt]="'AI TravelBuddy Avatar'"
          cls="rounded-full !w-16 mobile:!w-10 mobile:max-w-[40px] mobile:max-h-[50px]"></ig-image>
        <div
          class="relative -top-6 text-white text-xs text-center font-semibold mobile:font-normal mobile:-top-4 mobile:text-[11px]">
          <div><span class="mobile:hidden">Chat now </span> <span class="mobile:hidden">with</span></div>
          <div>{{ travelBuddySettings.ui.avatar.name || 'AI Travel Planner' }}</div>
          <!-- <div>AI <br class="hidden mobile:block">TravelBuddy!</div> -->
        </div>
      </div>
      <mat-icon *ngIf="isShow"
        class="text-white flex items-center justify-center !text-[24px] !leading-6 !w-14 !h-14 bg-gray-600 rounded-full p-2 mobile:!text-[26px] mobile:!leading-[26px] mobile:p-3 mobile:!w-8 mobile:!h-8"
        aria-hidden="true">keyboard_arrow_down</mat-icon>
    </div>
  </ng-template>
</ng-container>


<div class="ig-im-mask fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-50 transition-opacity duration-300"
  role="button" [attr.tabindex]="isShow ? 0 : -1" (keydown)="onPseudoButtonKeydown($event)" (click)="show()"
  [attr.aria-label]="'Close chat'" [attr.aria-expanded]="isShow" [attr.aria-hidden]="!isShow"
  [class.opacity-0]="!isShow" [class.pointer-events-none]="!isShow" [class.opacity-50]="isShow"></div>

<div #container id="chat-container" role="dialog" aria-label="AI TravelBuddy Chat" aria-modal="true" tabindex="-1"
  [attr.aria-hidden]="!isShow" [attr.inert]="!isShow ? '' : null" class="fixed bg-white overflow-hidden max-h-[90vh] h-[90vh]
    transition-all duration-300 z-[1300] text-gray-600 flex shadow-lg rounded-2xl
    mobile:w-[95vw] mobile:max-w-[95vw] mobile:h-[90vh] mobile:max-h-[90vh] mobile:rounded-none
    ig-im-msg-box" [class.show]="isShow" [class.ig-im-app-mode]="containerMode()==='app'" [class.h-0]="!isShow" [class.w-0]="!isShow" [class.opacity-0]="!isShow"
  [class.w-[90vw]]="!isMapOpen" [class.max-w-[1500px]]="isShowLandscreen && isShowFeaturedPlaces"
  [class.max-w-[1200px]]="(!isShowLandscreen && !isMapOpen && !isDetailsOpen) || (isSidebarCollapsed && (isMapOpen || isDetailsOpen))"
  [class.w-[95vw]]="isMapOpen" [class.max-w-[1600px]]="(isMapOpen || isDetailsOpen) && !isSidebarCollapsed"
  [ngStyle]="{'right': chatRight, 'bottom': chatBottom, 'left': chatLeft, 'top': chatTop}">

  <!-- Left Sidebar -->
  <div class="bg-white flex flex-col min-h-0 mobile:w-[80%] mobile:border-r-0 mobile:absolute mobile:z-10 mobile:h-full
        transition-all duration-300 ease-in-out top-0 mobile:z-50 mobile:left-0 mobile:shadow-lg mobile:rounded-lg"
    [class.!left-[-100%]]="isMobile && isSidebarCollapsed" [class.w-80]="!isSidebarCollapsed"
    [class.w-14]="isSidebarCollapsed" [class.overflow-hidden]="isSidebarCollapsed">

    <!-- Sidebar Toggle Button (Desktop Only) -->
    <button *ngIf="!isSidebarCollapsed" (click)="toggleSidebarCollapse()" aria-label="Collapse sidebar"
      [attr.aria-expanded]="!isSidebarCollapsed"
      class="absolute left-[17.5rem] top-6 z-20 w-6 h-6 bg-white flex items-center justify-center transition-all duration-200 mobile:left-auto mobile:right-4"
      title="Collapse sidebar">
      <mat-icon class="text-gray-400 custom-line-height text-[20px]">menu</mat-icon>
    </button>

    <!-- Sidebar Header -->
    <div class="p-6 pr-4 border-b border-gray-200" [class.hidden]="isSidebarCollapsed">
      <div class="flex items-center gap-3" [class.mb-6]="!isShowLandscreen">
        @if (frontendSettings$ | async; as settings) {
        <ig-image
          [src]="settings?.ai?.travelBuddy?.ui?.avatar?.profile || 'https://imgoingcalendar.com/assets/imgs/ImGoingLogo-2018-3.png'"
          class="w-12 h-15 rounded-full" cls="!w-12 !h-15"></ig-image>
        } @else {
        <ig-image
          [src]="travelBuddySettings?.ui?.avatar?.profile || 'https://imgoingcalendar.com/assets/imgs/ImGoingLogo-2018-3.png'"
          class="w-12 h-15 rounded-full" cls="!w-12 !h-15"></ig-image>
        }
        <div class="flex-1">
          <h2 class="text-lg font-semibold text-gray-800 translate-y-[6px]">Hello, I'm{{ hubName === 'OrangeCoNY' ? '' : ' the' }}</h2>
          <h2 class="text-lg font-semibold text-[#235e66]">{{ travelBuddySettings?.ui?.avatar?.name || 'AI Travel Planner' }}!
          </h2>
        </div>
      </div>

      <!-- New Chat Button -->
      <button *ngIf="!isShowLandscreen" (click)="startNewChat()" [disabled]="isWaitingForAIResponse"
        class="w-full bg-white text-[#256e7c] border-2 border-[#095d6e] px-4 py-3 rounded-lg font-bold text-center hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
        <span>+ New chat</span>
      </button>
    </div>

    @defer (on timer(3000)) {
      <div *ngIf="isShowSharedTripPrompt"
        class="fixed inset-0 z-[1600] bg-black bg-opacity-40 flex items-center justify-center p-4">
        <div class="w-full max-w-md bg-white rounded-xl shadow-xl p-6 text-center">
          <div class="text-lg font-semibold text-gray-800">A trip has been shared to you</div>
          <div class="text-sm text-gray-500 mt-2">Click below to view the shared trip.</div>
          <div class="mt-5 flex items-center justify-center gap-3">
            <button (click)="onViewSharedTripClick()" [disabled]="isLoadingSharedTrip"
              class="bg-[#256e7c] text-white px-5 py-2 rounded-lg hover:bg-[#1a5966] transition-colors">
              {{ isLoadingSharedTrip ? 'Loading...' : 'Show shared trip' }}
            </button>
            <button (click)="closeSharedTripPrompt()"
              class="bg-white text-gray-600 border border-gray-300 px-5 py-2 rounded-lg hover:bg-gray-50 transition-colors">
              Close
            </button>
          </div>
        </div>
      </div>
      }

    <!-- Recent Chats -->
    <div class="flex-1 min-h-0 p-4 pr-1 flex flex-col gap-3 h-[calc(100%-345px)]" [class.hidden]="isSidebarCollapsed">
      @defer (on timer(3000)) {
      <span *ngIf="hasSharedTripInUrl" (click)="onViewSharedTripClick()" role="button" tabindex="0"
        (keydown)="onPseudoButtonKeydown($event)" aria-label="Open shared trip"
        class="text-sm text-[#256e7c] px-3 !underline hover:text-[#1a5966] cursor-pointer text-center">
        A trip has been shared to you
      </span>
      }

      <div class="overflow-y-auto flex-1">
        <!-- Favorites Section -->
        <div *ngIf="favoritePlaces?.length > 0" class="mt-2 ig-tb-fav-list" [class.hidden]="!isUserLoggedIn" #favList>
          <div class="max-h-96 overflow-y-auto px-3 pb-2 relative">
            <ig-accordion mode="expand" [canItemClear]="false" [title]="'My Favorites'" [prefixIcon]="'favorite'"
              (click)="accordionClick($event)">
              <ng-container expand>
                <div *ngFor="let place of favoritePlaces"
                  class="!flex items-center gap-2 p-2 rounded-lg hover:bg-gray-100 cursor-pointer !border-none group relative"
                  role="button" tabindex="0" (keydown)="onPseudoButtonKeydown($event)"
                  [attr.aria-label]="'Open favorite ' + place.name"
                  (click)="selectFavItem(place)">
                  <div class="w-10 h-10 rounded-md overflow-hidden flex-shrink-0">
                    <ig-image [src]="place.cover?.source" [alt]="place.name" class="w-full h-full object-cover"
                      cls="h-full">
                    </ig-image>
                  </div>
                  <span class="text-sm font-medium text-gray-700 truncate">{{ place.name }}</span>

                  <button #removeFavoriteMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="removeFavoriteMenu"
                    igClickStopPropagation
                    [attr.aria-label]="'Open remove favorite menu for ' + place.name" aria-haspopup="menu"
                    class="opacity-0 group-hover:opacity-100 mobile:opacity-100 transition-all text-red-500 absolute right-[1px] w-7 h-7 flex items-center justify-center bg-transparent rounded-full hover:bg-gray-200">
                    <mat-icon class="text-sm leading-6 text-red-500">delete</mat-icon>
                  </button>
                  <mat-menu #removeFavoriteMenu="matMenu" igClickStopPropagation>
                    <div class="p-4">
                      <div class="text-sm text-gray-600 flex gap-1">
                        <mat-icon class="text-sm leading-6 text-red-500">warning</mat-icon>
                        Are you sure you want to remove this item from favorites?
                      </div>
                      <div class="flex gap-2 mt-3 relative justify-center">
                        <button class="bg-red-400 px-4 py-1 rounded-md text-white"
                          (click)="removeFavorite(place)">Yes</button>
                        <button class="bg-white border border-gray-300 px-4 py-1 rounded-md text-gray-600"
                          (click)="removeFavoriteMenuTrigger?.closeMenu()" igClickStopPropagation>No</button>
                      </div>
                    </div>
                  </mat-menu>
                </div>
              </ng-container>
            </ig-accordion>
          </div>
        </div>

        <div *ngIf="savedAITrips?.trips?.length > 0" class="mt-2 ig-tb-fav-list" [class.hidden]="!isUserLoggedIn"
          #aiTripList>
          <div class="max-h-96 overflow-y-auto px-3 pb-2 relative">
            <ig-accordion mode="expand" [canItemClear]="false" [title]="'My AI Trips'" [prefixIcon]="'flight'"
              (click)="accordionClick($event)">
              <ng-container expand>
                <div *ngFor="let trip of savedAITrips?.trips"
                  class="!flex items-center gap-2 p-2 rounded-lg hover:bg-gray-100 cursor-pointer !border-none group relative"
                  role="button" tabindex="0" (keydown)="onPseudoButtonKeydown($event)"
                  [attr.aria-label]="'Open AI trip ' + trip.title"
                  [attr.aria-current]="selectedAITrip?._id === trip._id ? 'true' : null"
                  (click)="canEditTrip=true; selectAITrip(trip)">
                  <span class="text-sm font-medium text-gray-700 truncate flex items-center gap-1">
                    <span>{{ trip.title }}</span>
                    <mat-icon *ngIf="selectedAITrip?._id === trip._id"
                      class="text-sm leading-6 text-green-500">check</mat-icon>
                  </span>

                  <button #removeTripMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="removeTripMenu"
                    igClickStopPropagation
                    [attr.aria-label]="'Open remove AI trip menu for ' + trip.title" aria-haspopup="menu"
                    class="opacity-0 group-hover:opacity-100 mobile:opacity-100 transition-all text-red-500 absolute right-[1px] w-7 h-7 flex items-center justify-center bg-transparent rounded-full hover:bg-gray-200">
                    <mat-icon class="text-sm leading-6 text-red-500">delete</mat-icon>
                  </button>
                  <mat-menu #removeTripMenu="matMenu" igClickStopPropagation>
                    <div class="p-4">
                      <div class="text-sm text-gray-600 flex gap-1 items-center">
                        <mat-icon class="text-sm !leading-6 text-red-500">warning</mat-icon>
                        Are you sure you want to remove this trip?
                      </div>
                      <div class="flex gap-2 mt-3 relative justify-center">
                        <ig-button color="warn" mode="flat" [isAsync]="true" igClickStopPropagation
                          (trigger)="removeAITrip($event, trip, removeTripMenuTrigger)">
                          Yes
                        </ig-button>
                        <button class="bg-white border border-gray-300 py-1 w-[64px] rounded-sm text-gray-600"
                          (click)="removeTripMenuTrigger?.closeMenu()" igClickStopPropagation>
                          No
                        </button>
                      </div>
                    </div>
                  </mat-menu>
                </div>
              </ng-container>
            </ig-accordion>
          </div>
        </div>

        <div class="h-5 px-3" [class.mt-3]="favoritePlaces?.length || savedAITrips?.trips?.length">
          <div class="flex justify-between items-center gap-3">
            <h3 class="text-sm font-medium text-gray-500">Recent chats</h3>

            <div [class.hidden]="!isUserLoggedIn" mat-icon-button [matMenuTriggerFor]="folderMenu"
              #createFolderMenuTrigger="matMenuTrigger"
              role="button" tabindex="0" (keydown)="onPseudoButtonKeydown($event)" aria-haspopup="menu"
              aria-label="Create new chat folder"
              class="text-gray-500 hover:text-gray-700 transition-colors flex items-center cursor-pointer pr-0"
              title="Create New Folder">
              <mat-icon class="!leading-6 text-center">create_new_folder</mat-icon>
              <span class="text-xs">New Folder</span>
            </div>
          </div>

          <mat-menu #folderMenu="matMenu" class="folder-menu">
            <div class="p-4 w-64" igClickStopPropagation>
              <mat-form-field appearance="outline" class="w-full">
                <mat-label>Folder Name</mat-label>
                <input matInput [(ngModel)]="newFolderName" (keyup.enter)="createNewFolder(createFolderMenuTrigger)"
                  #folderInput>
              </mat-form-field>
              <div class="flex justify-end gap-2">
                <button class="ig-tb-btn-gradient px-4 py-1.5 rounded-md text-white"
                  (click)="createNewFolder(createFolderMenuTrigger)">
                  Create
                </button>
              </div>
            </div>
          </mat-menu>

          <div *ngIf="!isUserLoggedIn && recentChats?.length === 0"
            class="mt-3 text-sm text-gray-500 italic flex justify-center w-full cursor-pointer"
            role="button" tabindex="0" (keydown)="onPseudoButtonKeydown($event)" aria-label="Open login dialog"
            (click)="showLoginPopup()">
            Want to keep your chats? <br>Login to save them.
          </div>
          <div *ngIf="isUserLoggedIn && !userChatFolders.length && !recentChats?.length"
            class="text-sm text-gray-500 italic mt-4 flex justify-center w-full cursor-pointer">No recent chats</div>
        </div>

        <div class="ig-tb-folder-list">
          <div *ngFor="let folder of userChatFolders" (click)="switchFolder(folder)"
            class="px-3 py-2 rounded-lg cursor-pointer text-sm text-gray-700 truncate relative"
            role="button" tabindex="0" (keydown)="onPseudoButtonKeydown($event)"
            [attr.aria-label]="'Open folder ' + folder.name"
            [attr.aria-current]="selectedFolder?._id === folder._id ? 'true' : null">

            <ig-accordion mode="expand" [canItemClear]="false" [title]="folder.name" (click)="accordionClick($event)">
              <ng-container expand>
                <div class="!flex flex-col gap-3 !h-fit !pb-4 !px-0 group">

                  <div *ngIf="folder.chats.length === 0"
                    class="text-sm text-gray-500 italic mt-4 flex justify-center w-full cursor-pointer">No chats in
                    this folder</div>
                  <div *ngFor="let chat of folder.chats"
                    class="relative hover:bg-gray-100 cursor-pointer px-3 py-1 group transition-opacity" (click)="loadChat(chat)"
                    [class.bg-gray-100]="chat.id === currentChat?.id"
                    [class.pointer-events-none]="isWaitingForAIResponse && chat.id !== currentChat?.id"
                    [class.opacity-50]="isWaitingForAIResponse && chat.id !== currentChat?.id">
                    <span class="truncate block">{{ chat.title }}
                    </span>

                    <button [class.invisible]="!isUserLoggedIn" #swapFolderMenuTrigger="matMenuTrigger"
                      [matMenuTriggerFor]="swapFolderMenu" igClickStopPropagation
                      [attr.aria-label]="'Open chat actions for ' + chat.title" aria-haspopup="menu"
                      (click)="$event.stopPropagation(); setCurrentChat(chat)"
                      class="opacity-0 group-hover:opacity-100 mobile:opacity-100 transition-all ext-gray-500 absolute top-0 right-[1px] w-7 h-7 flex items-center justify-center bg-transparent rounded-full">
                      <mat-icon class="text-sm leading-6 text-gray-400">settings</mat-icon>
                    </button>

                    <div class="text-xs text-gray-400 flex items-center justify-between">
                      <span>{{ chat.timestamp | date:'short' }}</span>
                      <mat-menu #swapFolderMenu="matMenu" yPosition="above"
                        class="w-[400px] !max-w-[400px] !overflow-hidden">

                        <div class="p-3 w-[400px]">
                          <div class="flex gap-2 p-2 mb-2" igClickStopPropagation role="tablist" aria-label="Chat options">
                            <div (click)="showUpdateChatTitleMenu()" role="tab" tabindex="0"
                              (keydown)="onPseudoButtonKeydown($event)" [attr.aria-selected]="isShowUpdateChatTitle"
                              class="text-center w-full cursor-pointer pb-2 border-purple-500"
                              [class.border-b-2]="isShowUpdateChatTitle">Update Chat Title</div>
                            <div (click)="showMoveChatMenu()" role="tab" tabindex="0"
                              (keydown)="onPseudoButtonKeydown($event)" [attr.aria-selected]="!isShowUpdateChatTitle"
                              class="text-center w-full cursor-pointer pb-2 border-purple-500"
                              [class.border-b-2]="!isShowUpdateChatTitle">Move to folder</div>
                          </div>
                          <div [class.hidden]="!isShowUpdateChatTitle" igClickStopPropagation>
                            <mat-form-field appearance="outline" class="w-full">
                              <mat-label>Update Chat Title</mat-label>
                              <input matInput [(ngModel)]="currentChatTitle"
                                (keyup.enter)="updateChatTitle();swapFolderMenuTrigger?.closeMenu()" #folderInput>
                            </mat-form-field>
                            <div class="flex justify-end gap-2">
                              <button *ngIf="isUserLoggedIn" class="bg-red-400 px-4 py-1.5 rounded-md text-white"
                                (click)="askDelete(chat.id)" #deleteTrigger="matMenuTrigger"
                                [matMenuTriggerFor]="deleteMenu" igClickStopPropagation>
                                Delete this chat
                              </button>
                              <mat-menu #deleteMenu="matMenu" igClickStopPropagation>
                                <div class="p-4">
                                  <div class="text-sm text-gray-600 flex gap-1">
                                    <mat-icon class="text-sm leading-6 text-red-500">warning</mat-icon>
                                    Are you sure you want to delete this chat?
                                  </div>
                                  <div class="flex gap-2 mt-3 relative justify-center">
                                    <button class="bg-red-400 px-4 py-1 rounded-md text-white"
                                      (click)="deleteChat(chat.id)">Yes</button>
                                    <button class="bg-white border border-gray-300 px-4 py-1 rounded-md text-gray-600"
                                      (click)="deleteTrigger?.closeMenu()" igClickStopPropagation>No</button>
                                  </div>
                                </div>
                              </mat-menu>
                              <button class="ig-tb-btn-gradient px-4 py-1.5 rounded-md text-white"
                                (click)="updateChatTitle();swapFolderMenuTrigger?.closeMenu()">
                                Update
                              </button>
                            </div>
                          </div>

                          <div [class.hidden]="isShowUpdateChatTitle || !isUserLoggedIn" igClickStopPropagation
                            class="p-4 pt-0">
                            <div *ngIf="userChatFolders.length === 0"
                              class="text-sm text-gray-500 italic mt-4 flex justify-center w-full cursor-pointer">No
                              folders</div>
                            <h4 *ngIf="userChatFolders.length > 0" class="text-sm font-medium !mb-2">Select Folder
                            </h4>
                            <div igClickStopPropagation class="max-h-[200px] overflow-y-auto">
                              <div *ngFor="let folder of userChatFolders" igClickStopPropagation
                                class="hover:bg-gray-100 cursor-pointer p-2">
                                <div class="flex items-center justify-between" igClickStopPropagation role="button"
                                  tabindex="0" (keydown)="onPseudoButtonKeydown($event)"
                                  [attr.aria-pressed]="selectedFolderId === folder._id"
                                  (click)="selectFolder(folder._id)">
                                  <span class="text-sm">{{ folder.name }}</span>
                                  <mat-icon *ngIf="selectedFolderId === folder._id"
                                    class="mr-2 text-green-500">check</mat-icon>
                                </div>
                              </div>
                            </div>
                            <div *ngIf="userChatFolders.length > 0" class="flex gap-2 mt-3 relative justify-end">
                              <button class="ig-tb-btn-gradient px-5 py-1.5 rounded-md text-white"
                                (click)="confirmMoveToFolder(selectedFolderId, $event); swapFolderMenuTrigger?.closeMenu()">
                                Move
                              </button>
                            </div>
                          </div>
                        </div>

                      </mat-menu>
                    </div>
                  </div>

                  <div
                    class="flex justify-center text-blue-500 text-xs underline cursor-pointer group-hover:opacity-100 group-hover:h-5 h-0 opacity-0 transition-all mobile:opacity-100 mobile:h-fit"
                    #editFolderMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="editFolderMenu"
                    role="button" tabindex="0" (keydown)="onPseudoButtonKeydown($event)" aria-haspopup="menu"
                    [attr.aria-label]="'Edit folder ' + folder.name"
                    (click)="currentFolderName = folder.name">
                    Edit folder
                  </div>

                  <mat-menu #editFolderMenu="matMenu" class="!max-w-[286px] w-[286px]">
                    <div class="p-4 w-full" igClickStopPropagation>
                      <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Folder Name</mat-label>
                        <input matInput [(ngModel)]="currentFolderName"
                          (keyup.enter)="updateFolder(folder._id, currentFolderName, editFolderMenuTrigger)"
                          #folderInput>
                      </mat-form-field>
                      <div class="flex justify-end gap-2">
                        <button class="bg-red-400 px-4 py-1.5 rounded-md text-white"
                          #deleteFolderTrigger="matMenuTrigger" [matMenuTriggerFor]="deleteFolderMenu"
                          igClickStopPropagation>
                          Delete this folder
                        </button>
                        <mat-menu #deleteFolderMenu="matMenu" igClickStopPropagation>
                          <div class="p-4">
                            <div class="text-sm text-gray-600 flex gap-1">
                              <mat-icon class="text-sm leading-6 text-red-500">warning</mat-icon>
                              Are you sure you want to delete this folder? All chats in this trip will be deleted.
                            </div>
                            <div class="flex gap-2 mt-3 relative justify-center">
                              <button class="bg-red-400 px-4 py-1 rounded-md text-white"
                                (click)="deleteFolder(folder._id)">Yes</button>
                              <button class="bg-white border border-gray-300 px-4 py-1 rounded-md text-gray-600"
                                (click)="deleteFolderTrigger?.closeMenu()" igClickStopPropagation>No</button>
                            </div>
                          </div>
                        </mat-menu>
                        <button class="ig-tb-btn-gradient px-4 py-1.5 rounded-md text-white"
                          (click)="updateFolder(folder._id, currentFolderName, editFolderMenuTrigger)">
                          Update
                        </button>
                      </div>
                    </div>
                  </mat-menu>
                </div>
              </ng-container>
            </ig-accordion>

          </div>
        </div>

        <div class="flex-1 overflow-y-auto transition-all duration-300" [class.max-h-0]="!isRecentChatsExpanded"
          [class.overflow-hidden]="!isRecentChatsExpanded">
          <div *ngFor="let chat of getStandaloneChats(); let i = index" (click)="loadChat(chat)"
            class="p-3 rounded-lg hover:bg-gray-100 cursor-pointer text-sm text-gray-700 truncate group relative transition-opacity"
            role="button" tabindex="0" (keydown)="onPseudoButtonKeydown($event)"
            [attr.aria-label]="'Open chat ' + chat.title" [attr.aria-current]="chat.id === currentChat?.id ? 'true' : null"
            [class.bg-amber-50]="chat.pinned && !newlyTransferredChatIds.has(chat.id)"
            [class.border]="chat.pinned && !newlyTransferredChatIds.has(chat.id)"
            [class.border-amber-200]="chat.pinned && !newlyTransferredChatIds.has(chat.id)"
            [class.chat-newly-transferred]="newlyTransferredChatIds.has(chat.id)"
            [class.pointer-events-none]="isWaitingForAIResponse && chat.id !== currentChat?.id"
            [class.opacity-50]="isWaitingForAIResponse && chat.id !== currentChat?.id">
            <div class="flex items-center justify-between">
              <span class="truncate pr-8" [class.font-medium]="chat.pinned">{{ chat.title }}</span>
              <div class="flex items-center gap-1 transition-opacity">

                <button #swapFolderMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="swapFolderMenu"
                  [attr.aria-label]="'Open chat actions for ' + chat.title" aria-haspopup="menu"
                  igClickStopPropagation (click)="$event.stopPropagation(); setCurrentChat(chat)" class="opacity-0 group-hover:opacity-100 mobile:opacity-100 transition-all ext-gray-500
                      absolute top-2 right-4 w-6 h-6 flex items-center justify-center bg-transparent rounded-full">
                  <mat-icon class="text-sm leading-6 text-gray-400">settings</mat-icon>
                </button>

                <mat-menu #swapFolderMenu="matMenu" yPosition="above" class="w-[400px] !max-w-[400px] !overflow-hidden">
                  <div class="p-3 w-[400px]">
                    <div class="flex gap-2 p-2 mb-2" igClickStopPropagation role="tablist" aria-label="Chat options">
                      <div (click)="showUpdateChatTitleMenu()" role="tab" tabindex="0"
                        (keydown)="onPseudoButtonKeydown($event)" [attr.aria-selected]="isShowUpdateChatTitle"
                        class="text-center w-full cursor-pointer pb-2 border-purple-500"
                        [class.border-b-2]="isShowUpdateChatTitle">Update Chat Title</div>
                      <div *ngIf="isUserLoggedIn" (click)="showMoveChatMenu()" role="tab" tabindex="0"
                        (keydown)="onPseudoButtonKeydown($event)" [attr.aria-selected]="!isShowUpdateChatTitle"
                        class="text-center w-full cursor-pointer pb-2 border-purple-500"
                        [class.border-b-2]="!isShowUpdateChatTitle">Move to Chat</div>
                    </div>
                    <div [class.hidden]="!isShowUpdateChatTitle" igClickStopPropagation>
                      <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Update Chat Title</mat-label>
                        <input matInput [(ngModel)]="currentChatTitle"
                          (keyup.enter)="updateChatTitle();swapFolderMenuTrigger?.closeMenu()" #folderInput>
                      </mat-form-field>
                      <div class="flex justify-end gap-2">
                        <button class="bg-red-400 px-4 py-1.5 rounded-md text-white" (click)="askDelete(chat.id)"
                          #deleteTrigger="matMenuTrigger" [matMenuTriggerFor]="deleteMenu" igClickStopPropagation>
                          Delete this chat
                        </button>
                        <mat-menu #deleteMenu="matMenu" igClickStopPropagation>
                          <div class="p-4">
                            <div class="text-sm text-gray-600 flex gap-1">
                              <mat-icon class="text-sm leading-6 text-red-500">warning</mat-icon>
                              Are you sure you want to delete this chat?
                            </div>
                            <div class="flex gap-2 mt-3 relative justify-center">
                              <button class="bg-red-400 px-4 py-1 rounded-md text-white"
                                (click)="deleteChat(chat.id)">Yes</button>
                              <button class="bg-white border border-gray-300 px-4 py-1 rounded-md text-gray-600"
                                (click)="deleteTrigger?.closeMenu()" igClickStopPropagation>No</button>
                            </div>
                          </div>
                        </mat-menu>
                        <button class="ig-tb-btn-gradient px-4 py-1.5 rounded-md text-white"
                          (click)="updateChatTitle();swapFolderMenuTrigger?.closeMenu()">
                          Update
                        </button>
                      </div>
                    </div>

                    <div [class.hidden]="isShowUpdateChatTitle || !isUserLoggedIn" igClickStopPropagation
                      class="p-4 pt-0">
                      <div *ngIf="userChatFolders.length === 0"
                        class="text-sm text-gray-500 italic mt-4 flex justify-center w-full cursor-pointer">No folders
                      </div>
                      <h4 *ngIf="userChatFolders.length > 0" class="text-sm font-medium !mb-2">Select Folder</h4>
                      <div igClickStopPropagation class="max-h-[200px] overflow-y-auto">
                        <div *ngFor="let folder of userChatFolders" igClickStopPropagation
                          class="hover:bg-gray-100 cursor-pointer p-2">
                          <div class="flex items-center justify-between" igClickStopPropagation role="button"
                            tabindex="0" (keydown)="onPseudoButtonKeydown($event)"
                            [attr.aria-pressed]="selectedFolderId === folder._id"
                            (click)="selectFolder(folder._id)">
                            <span class="text-sm">{{ folder.name }}</span>
                            <mat-icon *ngIf="selectedFolderId === folder._id"
                              class="mr-2 text-green-500">check</mat-icon>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="userChatFolders.length > 0" class="flex gap-2 mt-3 relative justify-end">
                        <button class="ig-tb-btn-gradient px-5 py-1.5 rounded-md text-white"
                          (click)="confirmMoveToFolder(selectedFolderId, $event); swapFolderMenuTrigger?.closeMenu()">
                          Move
                        </button>
                      </div>
                    </div>
                  </div>
                </mat-menu>
              </div>
            </div>
            <div class="text-xs text-gray-400 mt-1">{{ chat.timestamp | date:'short' }}</div>
          </div>
        </div>
      </div>

    </div>


    <!-- Sidebar Footer -->
    <div class="p-4 border-t border-gray-200" [class.hidden]="isSidebarCollapsed">
      <div class="space-y-3">
        <!-- <a href="#" class="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-800">
            <mat-icon class="text-gray-400">help_outline</mat-icon>
            <span>Help</span>
          </a> -->
        <a [href]="frontendSettings?.customSettings?.ai?.travelBuddy?.ui?.otherInfo?.privacyPolicyLink || 'https://iti-digital.com/dxp-saas-terms-of-service/'"
          target="_blank" class="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-800">
          <mat-icon class="leading-6 text-center">help_outline</mat-icon>
          <span>Terms of Service & Privacy</span>
        </a>
        <button *ngIf="frontendSettings.customSettings?.ai?.travelBuddy?.ui?.otherInfo?.visitorGuideLink"
          (click)="openVisitorGuide()"
          class="request-guide-btn w-full ig-tb-btn-gradient text-white px-4 py-3 rounded-lg text-base font-bold hover:opacity-90 transition-opacity shadow-lg">
          Visitors Guide
        </button>
        <a href="https://iti-digital.com/" target="_blank"
          class="flex items-center justify-center gap-2 text-sm text-gray-400">
          <span>Powered by</span>
          <ig-image
            [src]="'https://iti-images.s3.us-east-1.amazonaws.com/imgs/ITI_Digital_Logo_2026.png'"
            class="h-7" cls="!h-7 !w-auto"></ig-image>
        </a>
      </div>
    </div>

    <!-- Expand Button when Sidebar is Collapsed -->
    <button #expandBtn *ngIf="isSidebarCollapsed" (click)="toggleSidebarCollapse()" aria-label="Expand sidebar"
      [attr.aria-expanded]="!isSidebarCollapsed"
      class="absolute top-6 z-20 left-6 w-6 h-6 bg-white flex items-center justify-center transition-all duration-200 mobile:hidden"
      title="Expand sidebar">
      <mat-icon class="text-gray-400 text-[20px]">auto_awesome_mosaic</mat-icon>
    </button>
  </div>


  <div class="flex flex-col min-h-0 gap-3 w-[calc(100%-320px)] flex-1 transition-all duration-300 mobile:w-full mobile:gap-0">
    <div class="bg-white h-[123px] shrink-0 mobile:h-[110px]" [class.!h-[66px]]="isShowLandscreen && !isMobile" [class.!h-[50px]]="isShowLandscreen && isMobile">
      <!-- Top Row: Title and User Info -->
      <div class="flex items-center justify-between px-6 pt-4 pb-1 mobile:px-4 mobile:pt-0">
        <div class="flex items-center gap-4 flex-1 mobile:gap-2">
          <!-- Mobile menu button (left side) -->
          <button (click)="toggleSidebarCollapse()" aria-label="Open sidebar"
            [attr.aria-expanded]="!isSidebarCollapsed"
            class="mobile:block hidden text-gray-400 hover:text-gray-600 -ml-2 mobile:bg-transparent">
            <div
              class="w-10 h-10 flex items-center justify-center rounded-lg bg-gray-100 mobile:w-8 mobile:bg-transparent">
              <mat-icon class="!leading-6">menu</mat-icon>
            </div>
          </button>

          <!-- Mobile User Info for logged in users -->
          <ng-container *ngIf="isUserLoggedIn">
            <div
              class="mobile:flex flex-1 hidden items-center gap-2 text-base font-bold text-gray-700 hover:bg-gray-100 px-3 py-2 rounded-lg transition-colors cursor-pointer relative"
              role="button" tabindex="0" (keydown)="onPseudoButtonKeydown($event)" aria-haspopup="menu"
              [matMenuTriggerFor]="mobileUserMenu">
              <ig-image [src]="userProfilePicture || defaultAvatar" class="w-8 h-8 rounded-full"></ig-image>
              <span class="mobile:font-normal">{{ getUserDisplayName() }}</span>
              <mat-icon class="text-gray-400">keyboard_arrow_down</mat-icon>
            </div>

            <!-- Mobile User Menu -->
            <mat-menu #mobileUserMenu="matMenu" class="user-menu">
              <div class="px-4 py-2 border-b border-gray-200">
                <div class="flex items-center gap-3">
                  <ig-image [src]="userProfilePicture || defaultAvatar" class="w-10 h-10 rounded-full"></ig-image>
                  <div>
                    <div class="font-medium text-gray-800">{{ getUserDisplayName() }}</div>
                    <div class="text-xs text-gray-500">{{ getUserEmail() }}</div>
                  </div>
                </div>
              </div>
              <div class="border-t border-gray-200"></div>
              <button mat-menu-item (click)="logout()" class="text-red-600">
                <mat-icon>logout</mat-icon>
                <span>Logout</span>
              </button>
            </mat-menu>
          </ng-container>

          <!-- Mobile Login/Guest Info for non-logged-in users -->
          <div *ngIf="!isUserLoggedIn" (click)="showLoginPopup()"
            class="mobile:flex hidden items-center gap-2 text-base font-bold text-gray-700 hover:bg-gray-100 px-3 py-2 rounded-lg transition-colors cursor-pointer"
            role="button" tabindex="0" (keydown)="onPseudoButtonKeydown($event)" aria-label="Open login dialog">
            <ig-image [src]="defaultAvatar" class="w-8 h-8 rounded-full"></ig-image>
            <span>{{ getUserDisplayName() === 'Guest' ? 'Login to Save Your Chats' : getUserDisplayName() }}</span>
            <!-- <mat-icon class="text-gray-400 align-center">login</mat-icon> -->
          </div>

          <!-- Desktop Title -->
          <div class="mobile:hidden flex-1">
            <div class="flex items-center gap-3">
              <h1 class="text-xl font-semibold text-gray-800 leading-tight line-clamp-2" [title]="currentChatTitle">
                {{currentChatTitle }}
              </h1>
              <!-- <div class="flex items-center gap-1.5 text-sm text-gray-500">
                  <span>{{ currentChatDate | date:'MMM dd, yyyy' }}</span>
                </div> -->
            </div>
          </div>
        </div>

        <!-- Desktop User Actions -->
        <div class="flex items-center gap-3 mobile:hidden">
          <!-- <mat-icon class="text-gray-400 cursor-pointer hover:text-gray-600 transition-colors">search</mat-icon>
            <mat-icon class="text-gray-400 cursor-pointer hover:text-gray-600 transition-colors">upload</mat-icon>
            <mat-icon class="text-gray-400 cursor-pointer hover:text-gray-600 transition-colors">chat</mat-icon>
            <mat-icon class="text-gray-400 cursor-pointer hover:text-gray-600 transition-colors">mail</mat-icon>

            <div class="h-8 w-px bg-gray-200 mx-1"></div> -->

          <!-- Show user info for logged in users -->
          <ng-container>
            <div class="flex items-center gap-2 cursor-pointer hover:bg-gray-50 px-3 py-2 rounded-lg transition-colors"
              role="button" tabindex="0" (keydown)="onPseudoButtonKeydown($event)"
              [attr.aria-haspopup]="isUserLoggedIn ? 'menu' : null"
              [attr.aria-label]="isUserLoggedIn ? 'Open user menu' : 'Open login dialog'"
              (click)="!isUserLoggedIn ? showLoginPopup() : null"
              [matMenuTriggerFor]="isUserLoggedIn ? userMenu : ''">
              <div class="flex items-center gap-2">
                <ig-image *ngIf="!userEmail" [src]="userFromStorage?.avatar || defaultAvatar"
                  class="w-10 h-10 rounded-full" cls="rounded-full min-h-10 min-w-10"></ig-image>
                <div *ngIf="userEmail"
                  class="w-10 h-10 min-w-10 min-h-10 aspect-square rounded-full bg-blue-200 text-sm font-semibold flex justify-center items-center text-blue-500 uppercase cursor-pointer">
                  <span>{{ userEmail.split('')[0] }}</span>
                </div>
                <span class="text-sm font-medium text-gray-700">{{ !isUserLoggedIn ? 'Login To Save Your Trips' :
                  getUserDisplayName() }}</span>
              </div>
              <mat-icon *ngIf="isUserLoggedIn"
                class="text-gray-400 !text-base !w-4 !h-4 !leading-4">keyboard_arrow_down</mat-icon>
            </div>

            <mat-menu #userMenu="matMenu" class="user-menu">
              <div class="px-4 py-2 border-b border-gray-200">
                <div class="flex items-center gap-3">
                  <div>
                    <div class="font-medium text-gray-800">{{ getUserDisplayName() }}</div>
                    <div class="text-xs text-gray-500">{{ getUserEmail() }}</div>
                  </div>
                </div>
              </div>
              <div class="border-t border-gray-200"></div>
              <button mat-menu-item (click)="logout()" class="text-red-600">
                <mat-icon>logout</mat-icon>
                <span>Logout</span>
              </button>
            </mat-menu>
          </ng-container>

          <!-- isUserLoggedIn1: {{isUserLoggedIn}}
            <div
              class="flex items-center gap-2 cursor-pointer hover:bg-gray-50 px-3 py-2 rounded-lg transition-colors">
              <ig-image [src]="userFromStorage?.avatar || defaultAvatar" class="w-8 h-8 rounded-full border-2 border-gray-200"></ig-image>
              <span (click)="showLoginPopup()" class="text-sm font-medium text-gray-700">{{ !isUserLoggedIn ? 'Login To Save Your Trips' : getUserDisplayName() }}</span>
            </div> -->
        </div>

        <!-- Mobile close button -->
        <button *ngIf="containerMode()!=='app'" (click)="show()" aria-label="Close chat"
          class="mobile:block hidden text-gray-400 hover:text-gray-600 mobile:right-2 rounded-full w-7 h-7 leading-7">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- Bottom Row: Filters Only -->
      <div *ngIf="!isShowLandscreen" class="px-6 pb-3 mobile:px-4 mobile:-translate-y-2">
        <div class="flex items-center gap-2">
          <div>
            <ig-date-range-picker #dateRangePicker [minDate]="minDate" [maxDate]="maxDate"
              (onRangeChanged)="dateRangeChanged($event)">
            </ig-date-range-picker>
          </div>

          <!-- Flexible Dates Toggle -->
          <button (click)="toggleFlexibleDates()" [class.bg-teal-50]="isFlexibleDates"
            [class.text-teal-700]="isFlexibleDates" [class.border-teal-300]="isFlexibleDates"
            [class.bg-gray-50]="!isFlexibleDates" [class.text-gray-600]="!isFlexibleDates"
            [class.border-gray-200]="!isFlexibleDates"
            class="flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 border rounded-lg hover:opacity-80 transition-all mobile:px-1"
            title="Toggle flexible dates">
            <span class="mobile:text-[9px]">Flexible Dates</span>
          </button>

          <!-- Category Filter Dropdown -->
          <button [matMenuTriggerFor]="categoryMenu" [class.bg-teal-50]="selectedPreferences.length > 0"
            [class.text-teal-700]="selectedPreferences.length > 0"
            [class.border-teal-300]="selectedPreferences.length > 0"
            [class.bg-gray-50]="selectedPreferences.length === 0"
            [class.text-gray-600]="selectedPreferences.length === 0"
            [class.border-gray-200]="selectedPreferences.length === 0"
            class="flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 border rounded-lg hover:opacity-80 transition-all mobile:px-1"
            title="Select preferences">
            <mat-icon class="!text-sm !w-4 !h-4 mobile:hidden">tune</mat-icon>
            <span class="mobile:text-[9px]">{{ selectedPreferences.length > 0 ? selectedPreferences.length + '
              Preferences' : 'Add Preferences' }}</span>
            <mat-icon class="!text-xs !w-3 !h-3 ml-0.5 mobile:hidden">arrow_drop_down</mat-icon>
          </button>

          <mat-menu #categoryMenu="matMenu" class="category-menu max-w-[320px]">
            <div class="px-4 py-3 max-w-sm" (click)="$event.stopPropagation()">
              <div class="text-sm font-semibold text-gray-800 mb-3">Select your preferences</div>
              <div class="flex flex-wrap gap-2">
                <button *ngFor="let preference of tripPreferences"
                  (click)="togglePreference(preference); $event.stopPropagation()"
                  [class]="preference.selected ? 'bg-teal-600 text-white border-teal-600' : 'bg-white border-gray-300 text-gray-700 hover:border-teal-400'"
                  class="text-xs font-medium px-3 py-1.5 border rounded-lg transition-all">
                  {{ preference.name }}
                </button>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>
    </div>

    <div class="flex flex-1 min-h-0 h-[calc(100%-135px)]" [class.!h-[calc(100%-66px)]]="isShowLandscreen && !isMobile" [class.!h-[calc(100%-50px)]]="isShowLandscreen && isMobile">
      <!-- Main Chat Area -->
      <div class="flex-[1] min-h-0 flex flex-col transition-all duration-300 overflow-hidden p-3 mobile:pb-0 mobile:pt-0 mobile:px-0"
        [class.mobile:w-full]="!isMapOpen">
        <!-- Chat Header -->

        <div #chatContainer
          class="flex-1 min-h-0 overflow-y-auto p-4 pt-0 bg-gray-100 rounded-t-2xl 3xl:p-6 mobile:p-0 mobile:bg-white ig-im-chat-container"
          [class.!px-0]="isMapOpen || isDetailsOpen">

          <!-- Mobile Welcome Section -->
          <div *ngIf="isShowLandscreen" class="bg-gray-100">
            <!-- Hero Image and Welcome Text -->
            <div class="bg-gray-100 rounded-3xl overflow-hidden">
              <div
                class="px-6 mt-12 flex items-center justify-center mobile:flex-col mobile:pt-2 mobile:mt-0 mobile:px-4 ig-im-intro-section">
                <div class="flex-[6] relative z-10">
                  <ig-image
                    [src]="travelBuddySettings?.ui?.introduction?.imageUrl || 'https://a.travel-assets.com/findyours-php/viewfinder/images/res70/553000/553962-savannah.jpg'"
                    class="w-full h-[20vh] rounded-2xl object-cover"
                    cls="w-full h-[20vh] rounded-2xl object-cover min-h-[235px]"></ig-image>
                </div>
                <div
                  class="rounded-2xl bg-white p-5 ml-[-5%] pl-[9%] flex-[6] min-h-[22vh] shadow-md mobile:mx-1 mobile:pl-6 mobile:pt-10 mobile:-translate-y-7">
                  <h1 class="text-2xl font-extrabold text-teal-800 mb-3 leading-7 ig-im-intro-title">
                    <span
                      *ngIf="travelBuddySettings?.ui?.introduction?.title">{{travelBuddySettings?.ui?.introduction?.title}}</span>
                    <span *ngIf="!travelBuddySettings?.ui?.introduction?.title">Welcome to <br> {{
                      travelBuddySettings?.cityName || 'this destination' }}!</span>
                  </h1>
                  <p class="text-gray-600 text-sm leading-relaxed !mt-5 !mb-3 max-h-[156px] overflow-y-auto ig-im-intro-content">
                    {{ travelBuddySettings?.ui?.introduction?.content || "I'm an AI powered travel assistant and
                    destination expert! To better plan your trip, click on a preferred question below." }}
                  </p>
                </div>
              </div>

              <div class="p-6 pb-0 mobile:pt-0 mobile:px-4 ig-im-preference-section">
                <div class="mobile:flex gap-4 items-center">
                  <h1 class="text-xl font-bold ig-tb-btn-gradient bg-clip-text text-transparent">
                    {{ travelBuddySettings?.ui?.tripPlanning?.planYourTripTitle || 'Plan Your Trip' }}
                  </h1>
                  <label *ngIf="tripPreferences.length > 0"
                    class="hidden text-sm text-gray-500 italic">Select all that apply:</label>
                </div>

                <!-- Date and Preferences -->
                <div class="my-4 mobile:my-2 ig-im-trip-planning-layout">
                  <div class="flex-[1] flex gap-2 ig-im-trip-date-row">
                    <div class="flex-[4] w-[193px]">
                      <ig-date-range-picker #dateRangePicker [minDate]="minDate" [maxDate]="maxDate"
                        (onRangeChanged)="dateRangeChanged($event)">
                      </ig-date-range-picker>
                    </div>

                    <button (click)="toggleFlexibleDates()"
                      [class]="isFlexibleDates ? 'ig-toggle-highlight text-white' : 'bg-white border border-gray-300 text-gray-500'"
                      class="!min-w-[60px] px-4 h-14 leading-[1.2] rounded-lg hover:opacity-90 transition-all font-semibold ig-im-trip-date-toggle">
                      Flexible Dates
                    </button>
                  </div>

                  <div *ngIf="tripPreferences.length > 0" class="flex-[1] mt-4 ig-im-trip-preferences-row mobile:!translate-y-0">
                    <label class="block text-sm text-gray-600 mb-2 italic">Select all that
                      apply:</label>
                    <div class="flex flex-wrap gap-2 mb-6 mobile:grid mobile:grid-cols-2 ig-im-trip-preferences-list">
                      <button *ngFor="let preference of tripPreferences" (click)="togglePreference(preference)"
                        [class]="preference.selected ? 'ig-toggle-highlight text-white' : 'bg-white border border-gray-300 text-gray-500'"
                        class="px-2 py-2 rounded-lg hover:opacity-90 transition-all text-xs">
                        {{ preference.name }}
                      </button>
                    </div>

                  </div>
                </div>

                <!-- Suggested Questions for Mobile -->
                <div class="grid grid-cols-2 gap-2 mobile:grid-cols-1">
                  <button *ngFor="let question of suggestedQuestions; let i = index"
                    (click)="sendQuestionWithContext(question)"
                    [class]="question.highlighted ? 'ig-toggle-highlight text-white shadow-lg' : 'bg-white border border-gray-300 text-gray-600 hover:bg-gray-50'"
                    class="w-full px-4 py-3 rounded-xl text-left flex items-center justify-between transition-all">
                    <span class="text-sm h-10 flex items-center" [class.text-white]="question.highlighted">{{
                      question.text }}</span>
                    <mat-icon [class.text-white]="question.highlighted"
                      class="text-gray-400 custom-line-height text-center">arrow_forward</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Chat Messages -->
          <div *ngIf="!isShowLandscreen" class="space-y-4 mobile:px-3">
            <div *ngFor="let msg of msgHistory; let i = index">
              <div *ngIf="msg.type === 'DATETIME'" class="my-4 text-gray-500 text-center">
                <span class="py-1 px-1.5 rounded-xs bg-gray-100 text-xs">{{ msg.msg }}</span>
              </div>
              <ig-msg-box *ngIf="msg.type !== 'DATETIME'" [message]="msg" [errorMsg]="errorMsgs[0]"
                [avatar]="userFromStorage?.avatar || defaultAvatar" [letterAvatar]="userEmail"
                [loadingTips]="loadingTips" [isAllowClick]="isUserLoggedIn" (feedbackEvent)="handleFeedback($event)"
                (avatarClicked)="logout()" [travelBuddySettings]="travelBuddySettings" (ask)="onSendClick.emit($event)"
                (tryAgain)="onTryAgain.emit($event)" (copyResponseEvent)="handleCopyResponse($event)"
                (shareResponseEvent)="handleShareResponse($event)" (saveForLaterEvent)="handleSaveForLater($event)"
                (likeEvent)="handleLikeResponse($event)" (dislikeEvent)="handleDislikeResponse($event)"
                (regenerateEvent)="handleRegenerateResponse($event)" (editMessageEvent)="handleEditMessage($event)"
                (saveTripEvent)="convertAndSaveAITrip($event)" (requestLoginEvent)="showLoginPopup()"
                class="animate-bottom-up">
                <ng-container adding>

                  <ng-container *ngIf="getAvailableMatchedPlaces(msg) as availableMatchedPlaces">
                    <div *ngIf="(availableMatchedPlaces.length || msg.eventsMatched?.length) && msg.type === 'AI'"
                      class="mt-4">
                    <div class="relative">
                      <button (click)="scrollPlaces('left')"
                        class="absolute left-0 top-1/2 -translate-y-14 z-10 h-9 w-9 bg-white/90 hover:bg-white shadow-md rounded-full p-2 transition-all"
                        [class.opacity-50]="!canScrollLeft" [disabled]="!canScrollLeft">
                        <mat-icon class="!w-5 !h-5 text-gray-700">chevron_left</mat-icon>
                      </button>

                      <!-- Right Arrow -->
                      <button (click)="scrollPlaces('right')"
                        class="absolute right-0 top-1/2 -translate-y-14 z-10 h-9 w-9 bg-white/90 hover:bg-white shadow-md rounded-full p-2 transition-all"
                        [class.opacity-50]="!canScrollRight" [disabled]="!canScrollRight">
                        <mat-icon class="!w-5 !h-5 text-gray-700">chevron_right</mat-icon>
                      </button>

                      <!-- Horizontal scroll container for places and events -->
                      <div #placesScrollContainer
                        class="horizontal-scroll-container flex gap-3 overflow-x-auto pb-2 scroll-smooth"
                        (scroll)="onPlacesScroll()">
                        <!-- Place Cards -->
                        <div *ngFor="let place of availableMatchedPlaces; let i = index"
                          class="place-card flex-shrink-0 w-[220px] border border-gray-200 bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow cursor-pointer"
                          role="button" tabindex="0" (keydown)="onPseudoButtonKeydown($event)"
                          [attr.aria-label]="'Open place details for ' + place.name"
                          (click)="selectPlace(place, i)">
                          <!-- Place Image -->
                          <div class="relative">
                            <ig-image [src]="place.cover?.source" [alt]="place.name"
                              class="w-full h-[160px] object-cover" cls="w-full h-[160px] object-cover"></ig-image>
                            <div *ngIf="place.rating"
                              class="absolute top-2 left-2 bg-yellow-400 text-gray-900 px-1.5 py-0.5 rounded flex items-center gap-0.5 text-xs font-bold">
                              <span>{{ place.rating }}</span>
                              <mat-icon class="!w-3 !h-3 !text-xs !leading-[11px]">star</mat-icon>
                            </div>
                          </div>

                          <!-- Place Title -->
                          <div class="p-2">
                            <h3 class="text-xs font-semibold text-gray-800 line-clamp-2">
                              {{ place.name }}
                            </h3>
                          </div>
                        </div>

                        <!-- Event Cards -->
                        <div *ngFor="let event of msg.eventsMatched; let i = index"
                          class="place-card flex-shrink-0 w-[220px] border border-gray-200 bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow cursor-pointer"
                          role="button" tabindex="0" (keydown)="onPseudoButtonKeydown($event)"
                          [attr.aria-label]="'Open event details for ' + event.name"
                          (click)="selectEvent(event, msg.eventsMatched.length + i)">
                          <!-- Event Image -->
                          <div class="relative">
                            <ig-image [src]="event.cover?.source" [alt]="event.name"
                              class="w-full h-[160px] object-cover" cls="w-full h-[160px] object-cover"></ig-image>
                            <div
                              class="absolute top-2 left-2 bg-blue-500 text-white px-1.5 py-0.5 rounded text-[10px] font-bold">
                              EVENT
                            </div>
                          </div>

                          <!-- Event Title -->
                          <div class="p-2">
                            <h3 class="text-xs font-semibold text-gray-800 line-clamp-2">
                              {{ event.name }}
                            </h3>
                          </div>
                        </div>
                      </div>

                      <button
                        class="w-full text-center mt-2 py-2 px-4 bg-gray-200 rounded-lg text-gray-600 font-semibold"
                        (click)="toggleMap(msg)">
                        Show Map
                      </button>

                      <div *ngIf="suggestedPrompts?.length > 0 && !isShowLandscreen" class="mb-4 mt-2 flex-col gap-2 flex-wrap hidden mobile:flex">
                        <button *ngFor="let prompt of suggestedPrompts" (click)="onSendClick.emit(prompt)"
                          class="p-2 flex-[1] bg-white text-left text-gray-500 rounded-lg border border-gray-300 text-xs hover:bg-gray-50 transition-colors">
                          {{ prompt }}
                        </button>
                      </div>
                    </div>

                    <!-- View Map Button -->
                    <!-- <div class="mt-4" *ngIf="matchedPlaces.length > 0 || matchedEvents.length > 0">
                        <button (click)="toggleMap()"
                          class="w-full bg-white border border-gray-300 text-gray-700 px-6 py-3 rounded-lg font-bold text-base hover:bg-gray-50 transition-colors shadow-sm flex items-center justify-center gap-2">
                          <mat-icon class="text-gray-600">map</mat-icon>
                          <span>{{ isMapOpen ? 'Focus Map' : 'View Layout Map' }}</span>
                        </button>
                      </div> -->
                    </div>
                  </ng-container>
                  <ng-content select="[adding]"></ng-content>
                </ng-container>
              </ig-msg-box>

              <ng-content *ngIf="msg.type==='AI'" select="[addition]"></ng-content>
            </div>
          </div>



        </div>

        <!-- Chat Input Area -->
        <div class="px-10 pt-4 pb-[3vh] h-[200px] shrink-0 bg-gray-100 bottom-0 left-0 w-full rounded-b-2xl mobile:px-4 mobile:pb-4 mobile:rounded-b-none ig-im-input-container"
          [class.!h-[110px]]="isShowLandscreen || suggestedPrompts?.length <= 0 || isMobile"
          [class.px-4]="isMapOpen || isDetailsOpen">
          <!-- Suggested Prompts -->
          <div *ngIf="suggestedPrompts?.length > 0 && !isShowLandscreen" class="mb-4 flex gap-2 flex-wrap mobile:hidden">
            <button *ngFor="let prompt of suggestedPrompts" (click)="onSendClick.emit(prompt)"
              class="px-4 py-3 flex-[1] bg-white text-left font-semibold border border-gray-300 text-gray-500 rounded-lg text-sm hover:bg-gray-50 mobile:py-2 mobile:text-xs mobile:font-normal transition-colors">
              {{ prompt }}
            </button>
          </div>



          <!-- Input Field -->
          <div class="flex items-start gap-3 relative">
            <!-- <mat-icon class="text-gray-400 cursor-pointer hover:text-gray-600 mobile:hidden mt-3">attach_file</mat-icon> -->
            <textarea #chatInput [(ngModel)]="msg" (keypress)="keypress($event)"
              placeholder="{{!isMobile ? 'Type your message here or pick from the prompts' : 'Type your message here'}}"
              rows="1"
              aria-label="Type your message" aria-describedby="chat-disclaimer"
              class="ig-im-input flex-1 p-4 border border-gray-300 bg-white text-black rounded-xl focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent shadow-sm resize-none overflow-hidden"
              (input)="autoResize($event)"></textarea>
            <button (click)="onSendClick.emit(msg)" aria-label="Send message"
              class="ig-im-send w-10 h-10 absolute right-2 bottom-[7px] bg-[#0f2729] text-white rounded-xl flex items-center justify-center hover:bg-[#1a3a3f] transition-colors shadow-sm flex-shrink-0">
              <mat-icon class="text-white !w-5 !h-5 !text-[20px] !leading-5">send</mat-icon>
            </button>
          </div>

          <!-- Disclaimer -->
          <div id="chat-disclaimer" class="mt-3 text-xs text-gray-500 text-center italic mobile:text-[10px]">
            The AI Travel Planner can make mistakes. Check important info.
            <!-- <label>
                  <input type="checkbox" [(ngModel)]="isCheckPlaceStatusInAdvance">
                  Check place status in advance
                </label> -->
          </div>
        </div>
      </div>

      <!-- Details Panel - Third Column (Place/Event Details) -->
      <div *ngIf="isDetailsOpen && selectedPlaceOrEvent"
        class="w-[40%] max-w-[500px] min-w-[400px] mb-4 bg-white flex flex-col
          mobile:w-full mobile:min-w-full mobile:border-l-0 mobile:border-t mobile:absolute mobile:inset-0 mobile:z-20 mobile:h-full overflow-hidden details-panel-container">
        <!-- Details Panel Header -->
        <div
          class="flex items-center justify-between gap-3 p-4 mx-4 rounded-lg border-b border-gray-200 bg-gray-50 sticky top-0 z-10">
          <h3 class="text-lg font-bold text-gray-800">{{ selectedPlaceOrEvent?.name }}</h3>
          <button (click)="closeDetailsPanel()" aria-label="Close details panel"
            class="text-gray-400 hover:text-gray-600 bg-gray-200 transition-colors w-7 h-7 rounded-full flex items-center justify-center">
            <mat-icon class="!leading-6">close</mat-icon>
          </button>
        </div>

        <!-- Details Content - Use modal service to open in panel context -->
        <div #detailsPanel class="flex-1 overflow-y-auto px-4 py-2 space-y-4">

          <!-- <ig-fancy-place-details-modal [currentPlace]="selectedPlaceOrEvent"></ig-fancy-place-details-modal> -->

          <div *ngIf="selectedPlaceOrEvent" class="h-full">
            <button *ngIf="!frontendSettings.ai.travelBuddy.isStandalone" (click)="openFullDetailsModal()"
              class="w-full ig-tb-btn-gradient text-white mt-1 px-4 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center gap-2 mb-1">
              <mat-icon class="!leading-6">open_in_full</mat-icon>
              <span>Open Full Details</span>
            </button>

            <div class="flex gap-2 mt-2 mb-3">
              <button (click)="viewOnMap(selectedPlaceOrEvent)"
                [class.!mt-0]="frontendSettings.ai.travelBuddy.isStandalone"
                class="w-full bg-white border-2 border-gray-300 text-gray-700 px-4 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors flex items-center justify-center gap-2">
                <mat-icon class="!leading-6">map</mat-icon>
                <span>View on Map</span>
              </button>

              <button
                class="w-full bg-white border-2 border-gray-300 text-gray-700 px-4 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors flex items-center justify-center gap-2"
                (click)="toggleFavorite(selectedPlaceOrEvent)"
                [class.text-red-500]="isUserLoggedIn && !isFavorite(selectedPlaceOrEvent)"
                [matTooltip]="isUserLoggedIn ? isFavorite(selectedPlaceOrEvent) ? 'Remove from Favorites' : 'Add to Favorites' : 'Please login to add to favorites'">
                <mat-icon class="!leading-6">
                  {{ isFavorite(selectedPlaceOrEvent) ? 'favorite' : 'favorite_border' }}
                </mat-icon>
                <span>Favorites</span>
              </button>
            </div>

            <!-- Simplified inline preview -->
            <div class="bg-white rounded-lg overflow-hidden shadow-md">
              <!-- Cover Image -->
              <div class="relative">
                <ig-image [src]="selectedPlaceOrEvent.cover?.source" [alt]="selectedPlaceOrEvent.name"
                  class="w-full h-[250px] object-cover" cls="w-full h-[250px] object-cover"></ig-image>
                <div *ngIf="getItemRating()"
                  class="absolute top-3 left-3 bg-yellow-400 text-gray-900 px-3 py-1 rounded-md flex items-center gap-1 font-bold shadow-lg">
                  <span>{{ getItemRating() }}</span>
                  <mat-icon class="!w-5 !h-5 !leading-5">star</mat-icon>
                </div>
              </div>

              <!-- Details -->
              <div class="p-6 space-y-2">
                <h2 class="text-xl font-bold text-gray-700">{{ selectedPlaceOrEvent?.name }}</h2>

                @if (!isSelectedItemEvent) {
                <div *ngIf="getItemCategory()" class="flex items-center gap-2 text-gray-600 text-sm">
                  <mat-icon class="!w-5 !h-5 min-w-5">category</mat-icon>
                  <span>{{ getItemCategory() }}</span>
                </div>

                <div *ngIf="getItemAddress()" class="flex items-start gap-2 text-gray-600 text-sm">
                  <mat-icon class="!w-5 !h-5 mt-0.5 min-w-5">location_on</mat-icon>
                  <span>{{ getItemAddress() }}</span>
                </div>

                <div *ngIf="getItemPhone()" class="flex items-center gap-2 text-gray-600 text-sm">
                  <mat-icon class="!w-5 !h-5 min-w-5">phone</mat-icon>
                  <a [href]="'tel:' + getItemPhone()" class="hover:text-blue-600">{{ getItemPhone() }}</a>
                </div>

                <div *ngIf="getItemWebsite()" class="flex items-center gap-2 text-gray-600 text-sm mb-2">
                  <mat-icon class="!w-5 !h-5 min-w-5">language</mat-icon>
                  <a [href]="getItemWebsite()" target="_blank" class="hover:text-blue-600 hover:underline">Visit
                    Website</a>
                </div>

                <div *ngIf="selectedPlaceOrEvent.priceRange" class="text-sm flex items-center gap-2">
                  <mat-icon class="!w-5 !h-5 min-w-5">currency</mat-icon>
                  <span class="text-gray-600 leading-relaxed">Price Range: {{ selectedPlaceOrEvent.priceRange
                    }}</span>
                </div>
                <div *ngIf="selectedPlaceOrEvent.user_ratings_total" class="text-sm flex items-center gap-2">
                  <mat-icon class="!w-5 !h-5 min-w-5">star</mat-icon>
                  <span class="text-gray-600 leading-relaxed">User Ratings Total: {{
                    selectedPlaceOrEvent.user_ratings_total }}</span>
                </div>

                <div *ngIf="isLoadingDetails"
                  class="pt-4 border-t border-gray-200 text-sm flex justify-center w-full pt-6">
                  <ig-loading-dot class="-translate-x-7"></ig-loading-dot>
                </div>

                <div *ngIf="getItemDescription()" class="pt-4 border-t border-gray-200 text-sm">
                  <h3 class="font-semibold text-gray-700 !mb-2">Description</h3>
                  <p class="text-gray-600 leading-relaxed">{{ getItemDescription() }}</p>
                </div>

                <div *ngIf="getItemOpeningHours()" class="pt-4 border-t border-gray-200 text-sm">
                  <h3 class="font-semibold text-gray-700 !mb-2">Opening Hours</h3>
                  <div
                    *ngFor="let day of getItemOpeningHours()?.weekday_text || selectedPlaceOrEvent.opening_hours?.weekdayDescriptions"
                    class="flex flex-col gap-1">
                    {{ day }}
                  </div>
                </div>

                <ig-place-services [place]="selectedPlaceOrEvent" [firstSectionBorder]="true"></ig-place-services>

                <div *ngIf="isLoadingNearbyPlaces || nearbyPlaces?.length >= 5"
                  class="pt-4 border-t border-gray-200 text-sm">
                  <h3 class="font-semibold text-gray-700 !mb-2">Explore Nearby</h3>
                  <div *ngIf="isLoadingNearbyPlaces" class="flex justify-center py-3">
                    <ig-loading-dot class="-translate-x-7"></ig-loading-dot>
                  </div>

                  <div *ngIf="!isLoadingNearbyPlaces"
                    class="flex items-center gap-3 overflow-x-auto pb-2 nearby-places-scroll">
                    <div *ngFor="let place of nearbyPlaces"
                      class="relative w-48 h-48 min-w-48 rounded-lg overflow-hidden cursor-pointer shrink-0"
                      role="button" tabindex="0" (keydown)="onPseudoButtonKeydown($event)"
                      [attr.aria-label]="'Open nearby place ' + place.name"
                      (click)="openPlaceInModal(place)">
                      <ig-image [src]="place.cover?.source" [alt]="place.name" class="w-full h-full"
                        cls="w-full h-full object-cover"></ig-image>
                      <div
                        class="absolute inset-x-0 pt-3 pb-[5px] leading-5 bottom-0 px-2 bg-gradient-to-t from-black to-transparent text-white text-xs font-medium line-clamp-2">
                        {{ place.name }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Reviews Section -->
                <div *ngIf="getGoogleReviews().length" class="pt-4 pb-3 border-t border-gray-200">
                  <h3 class="font-semibold text-gray-700 !mb-4">Google Reviews</h3>
                  <div class="">
                    <div *ngFor="let review of getGoogleReviews()" class="bg-white p-4 rounded-lg shadow-sm">
                      <div class="flex items-center justify-between mb-2">
                        <div class="flex items-center">
                          <!-- <ig-image *ngIf="review.authorAttribution?.photoUri"
                                   [src]="review.authorAttribution.photoUri"
                                   alt="Reviewer"
                                   class="w-10 h-10 rounded-full mr-3">
                              </ig-image> -->
                          <div>
                            <div class="font-medium text-gray-900">
                              {{ review.authorAttribution?.displayName || review.author_name || 'Anonymous' }}
                            </div>
                            <div class="flex items-center">
                              <div class="flex text-yellow-400">
                                <span *ngFor="let i of [1,2,3,4,5]">
                                  <svg *ngIf="i <= review.rating" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4"
                                    viewBox="0 0 20 20" fill="currentColor">
                                    <path
                                      d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                  </svg>
                                  <svg *ngIf="i > review.rating" xmlns="http://www.w3.org/2000/svg"
                                    class="h-4 w-4 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                      d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                                  </svg>
                                </span>
                              </div>
                              <span class="ml-2 text-sm text-gray-500">{{ review.relativePublishTimeDescription ||
                                review.dateTimeISOString }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="mt-2 text-gray-700 text-sm">
                        <p class="whitespace-pre-line">
                          <ng-container *ngIf="isReviewExpanded(review); else previewText">
                            {{ getReviewText(review) }}
                          </ng-container>
                          <ng-template #previewText>
                            {{ getReviewText(review) | slice:0:200 }}
                            <span *ngIf="getReviewText(review)?.length > 200">...</span>
                          </ng-template>
                          <button *ngIf="getReviewText(review)?.length > 200"
                            class="text-blue-600 text-sm font-medium ml-1 bg-transparent"
                            (click)="toggleReviewExpansion(review)">
                            {{ isReviewExpanded(review) ? 'Show less' : 'Read more' }}
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                } @else {
                <div *ngIf="selectedPlaceOrEvent.timeOneLine" class="flex items-center gap-2 text-gray-600 text-sm">
                  <mat-icon class="!w-5 !h-5 min-w-5">schedule</mat-icon>
                  <div>
                    <!-- <div *ngFor="time of selectedPlaceOrEvent.eventTimes">
                          {{ time.timeOneLine }}
                        </div> -->
                    {{ selectedPlaceOrEvent.timeOneLine }}
                  </div>
                </div>

                <div *ngIf="selectedPlaceOrEvent.address?.address" class="flex items-start gap-2 text-gray-600 text-sm">
                  <mat-icon class="!w-5 !h-5 mt-0.5 min-w-5">location_on</mat-icon>
                  <span>{{ selectedPlaceOrEvent.address.address }}</span>
                </div>
                <div *ngIf="selectedPlaceOrEvent.isOnlineEvent" class="flex items-start gap-2 text-gray-600 text-sm">
                  <mat-icon class="!w-5 !h-5 mt-0.5 min-w-5">location_on</mat-icon>
                  <span>Online Event</span>
                </div>

                <div *ngIf="selectedPlaceOrEvent.owner && selectedPlaceOrEvent.hostLink"
                  class="flex items-start gap-2 text-gray-600 text-sm">
                  <mat-icon class="!w-5 !h-5 mt-0.5 min-w-5">location_on</mat-icon>
                  <a [href]="selectedPlaceOrEvent.hostLink" target="_blank">{{ selectedPlaceOrEvent.owner.name }}</a>
                </div>

                <div *ngIf="selectedPlaceOrEvent.description" class="pt-4 border-t border-gray-200 text-sm">
                  <h3 class="font-semibold text-gray-700 !mb-2">Description</h3>
                  <div class="text-gray-600 leading-relaxed" [innerHTML]="selectedPlaceOrEvent.description"></div>
                </div>
                }
              </div>
            </div>


          </div>
        </div>
      </div>

      <div *ngIf="isDetailsOpen && selectedAITrip"
        class="w-[40%] max-w-[500px] min-w-[400px] mb-4 pr-4 bg-white flex flex-col mobile:w-full mobile:min-w-full mobile:border-l-0 mobile:border-t mobile:absolute mobile:inset-0 mobile:z-20 mobile:h-full overflow-hidden details-panel-container">
        <ig-trip-editor [currentTrip]="selectedAITrip" [userEntireTripId]="savedAITrips?._id" [hubName]="hubName"
          [userInfo]="userFromStorage" [cityName]="frontendSettings?.ai?.travelBuddy?.cityName || hubName"
          [canSaveMoreTrips]="savedAITrips?.trips?.length < maxSavedAITrips" [canEditTrip]="canEditTrip"
          (onCloseDetailsPanel)="closeDetailsPanel()" (onCopyTrip)="copyTrip($event)" class="w-full h-full"
          (onRequireLogin)="onTripEditorRequireLogin($event)"
          (onClickAttraction)="openPlaceInModal($event)"></ig-trip-editor>
      </div>

      <!-- Map Panel - Third Column -->
      <div *ngIf="isMapOpen && welcomePageMapMarkers.length > 0 && !isDetailsOpen" class="flex-[1] relative bg-white flex flex-col mobile:w-[80%] mobile:min-w-[80%] mobile:border-l-0
            mobile:border-t mobile:absolute mobile:inset-0 mobile:z-20 mobile-map-panel">
        <!-- Map Close Button -->
        <div class="absolute top-4 left-4 z-10">
          <button (click)="closeMap()"
            class="bg-[#1a575f] text-white px-4 py-2 rounded-full flex items-center gap-2 hover:bg-[#245865] transition-colors shadow-lg mobile:text-base">
            <span class="text-sm font-bold mobile:text-base">Close Map</span>
          </button>
        </div>

        <!-- Google Map Container -->
        <div class="w-full h-full flex-1 relative p-3 pl-0 mobile:p-3">
          <ig-google-map #googleMapComponent [markers]="welcomePageMapMarkers"
            [canInfoWindowClick]="!frontendSettings?.ai?.travelBuddy?.isStandalone"
            [options]="{zoom: 13, disableDefaultUI: false}" [isShowMyLocationControl]="false" [useCluster]="true"
            zoomControlPosition="LEFT_BOTTOM"
            (onInfoWindowClick)="onMapAttractionOpened()"
            class="w-full h-full">
          </ig-google-map>

          <!-- Route Drawing Controls -->
          <div
            *ngIf="welcomePageMapMarkers.length > 1 || (isCurrentItineraryResponse && welcomePageMapMarkers.length > 0)"
            class="absolute bottom-10 left-4 right-4 flex justify-center gap-3">
            <button *ngIf="!directionType" (click)="drawDirectionRoute()"
              class="ig-tb-btn-gradient text-white px-4 py-2 rounded-lg font-semibold shadow-lg transition-colors flex items-center gap-2">
              <mat-icon class="text-sm">route</mat-icon>
              {{ isCurrentItineraryResponse && directionLocations.length === 0 ? 'Create Route' : 'Draw Route' }}
            </button>
            <!-- <button *ngIf="directionType==='normal'" (click)="optimizeDirectionRouteByDistance()"
                class="ig-tb-btn-gradient text-white px-4 py-2 rounded-lg font-semibold shadow-lg transition-colors flex items-center gap-2">
                <mat-icon class="text-sm">tune</mat-icon>
                Optimize Route
              </button> -->
            <button *ngIf="directionType" (click)="getDirections()"
              class="ig-tb-btn-gradient text-white px-4 py-2 rounded-lg font-semibold shadow-lg transition-colors flex items-center gap-2">
              <mat-icon class="text-sm !leading-[26px]">navigation</mat-icon>
              Get Directions
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isShowLandscreen && isShowFeaturedPlaces && getPlacesForLandingPage()?.length"
    class="w-[25vw] p-4 mobile:hidden max-w-[400px]">
    <div class="h-full flex flex-col">
      <h3 class="font-semibold text-gray-700 !mt-3">Places to Explore</h3>
      <p class="text-gray-500 text-sm !mb-3">Select a place to start a conversation.</p>

      <ng-container *ngIf="getPlacesForLandingPage()?.length; else noFeaturedPlaces">
        <div #featuredPlacesContainer class="grid grid-cols-2 gap-3 overflow-y-auto flex-1 content-start">
          <div *ngFor="let place of getPlacesForLandingPage()"
            class="relative h-32 rounded-lg overflow-hidden cursor-pointer border border-gray-200 shadow-sm hover:shadow-md transition-shadow"
            role="button" tabindex="0" (keydown)="onPseudoButtonKeydown($event)"
            [attr.aria-label]="'Ask about ' + place.name"
            (click)="askAboutFeaturedPlace(place)">
            <ig-image [src]="place.cover?.source" [alt]="place.name" class="w-full h-full"
              cls="w-full h-full object-cover"></ig-image>
            <div
              class="absolute inset-x-0 bottom-0 px-2 py-1.5 bg-gradient-to-t from-black/80 to-transparent text-white text-xs font-medium line-clamp-2">
              {{ place.name }}
            </div>
          </div>
          <div type="button" role="button" tabindex="0" (keydown)="onPseudoButtonKeydown($event)"
            aria-label="Scroll featured places back to the top"
            class="col-span-2 mt-1 mb-1 text-center text-sm text-teal-700 hover:text-teal-900 underline underline-offset-2 ig-im-featured-place-back-to-top-btn"
            (click)="scrollFeaturedPlacesToTop(featuredPlacesContainer)">
            Back to the Top
          </div>
          </div>
      </ng-container>

      <ng-template #noFeaturedPlaces>
        <div class="text-sm text-gray-500 italic">No featured places available.</div>
      </ng-template>
    </div>
  </div>

</div>

<div *ngIf="isSharedTripModalOpen && sharedTripModalTrip"
  class="fixed inset-0 z-[2100] bg-black bg-opacity-45 p-4 flex items-center justify-center"
  (click)="closeSharedTripOverlay()">
  <div
    #sharedTripDialog
    class="relative w-[95vw] max-w-[1400px] h-[90vh] p-6 bg-[#dee5ea] rounded-2xl overflow-hidden shadow-2xl mobile:p-0 mobile:w-full mobile:h-full mobile:rounded-none"
    role="dialog" aria-modal="true" aria-label="Shared trip details" tabindex="-1" (click)="$event.stopPropagation()">

    <ig-trip-editor [currentTrip]="sharedTripModalTrip" [userEntireTripId]="savedAITrips?._id" [hubName]="hubName"
      [userInfo]="userFromStorage" [cityName]="frontendSettings?.ai?.travelBuddy?.cityName || hubName"
      [canSaveMoreTrips]="savedAITrips?.trips?.length < maxSavedAITrips" [canEditTrip]="false" class="w-full h-full"
      (onCloseDetailsPanel)="closeSharedTripOverlay()" (onCopyTrip)="copyTrip($event)"
      (onRequireLogin)="onTripEditorRequireLogin($event)"
      (onClickAttraction)="openPlaceInModal($event)"></ig-trip-editor>
  </div>
</div>

<!-- Login Popup Modal -->
<div [class.!flex]="isShowLoginPopup"
  [attr.aria-hidden]="!isShowLoginPopup" [attr.inert]="!isShowLoginPopup ? '' : null"
  class="fixed hidden inset-0 bg-black bg-opacity-50 z-[2200] items-center justify-center p-4">
  <div #loginDialog class="bg-white rounded-2xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto login-popup"
    role="dialog" aria-modal="true" aria-labelledby="login-popup-title" tabindex="-1">
    <!-- Modal Header -->
    <div class="flex items-center justify-between p-6 border-b border-gray-200">
      <h2 id="login-popup-title" class="text-xl font-bold text-gray-700">Login to Save Your Trips</h2>
      <button (click)="closeLoginPopup()" aria-label="Close login dialog" class="text-gray-400 hover:text-gray-600 back background-none">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Modal Content -->
    <div class="p-6 center">
      <p class="text-gray-600 !mb-6 text-center">
        Sign in to save your trip plans, revisit your AI conversations, and continue planning seamlessly across any device.
      </p>

      <ig-social-login #socialLogin (onLoginStatusChanged)="loginStatusChanged($event)"></ig-social-login>

      <!-- Email Login Option -->
      <div class="mt-6 pt-6 border-t border-gray-200">
        <h3 class="text-sm font-medium text-gray-500 mb-3 -translate-y-3">Or continue with email</h3>
        <form (ngSubmit)="gotoChatWithEmail()" class="space-y-3">
          <input type="email" [(ngModel)]="emailInput" name="email" placeholder="Enter your email address"
            aria-label="Email address"
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
            required>
          <div *ngIf="emailErrorMsg" class="text-red-500 text-sm">{{ emailErrorMsg }}</div>
          <button type="submit"
            class="w-full bg-teal-600 text-white py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors">
            Continue with Email
          </button>
        </form>
      </div>

      <!-- Anonymous Option -->
      <div class="mt-4 text-center">
        <button (click)="continueAsGuest()" class="text-gray-500 text-sm underline background-none">
          Continue as Guest
        </button>
      </div>
    </div>
  </div>
</div>


